import { statementSchema } from '@billing/validation/statement';
import { Provider, Site } from 'interfaces';

export interface Statement {
  id: string;
  providerID: string;
  startDate: string;
  endDate: string;
  reportPath: string;
  statementPath: string;
  provider: Provider;
  totalAmount: number;
  site?: Site;
}

export const isStatement = (obj: any): obj is Statement => {
  return statementSchema.safeParse(obj).success;
};
